import types from '../mutation-types';
import BillingAPI from '../../api/billing';
import { throwErrorMessage } from '../utils/api';

export const state = {
  record: {},
  uiFlags: { isFetching: false, isRedirecting: false },
};

export const getters = {
  getSubscription: $state => $state.record,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_BILLING_UI_FLAG, { isFetching: true });
    try {
      const { data } = await BillingAPI.get();
      commit(types.SET_BILLING_SUBSCRIPTION, data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_BILLING_UI_FLAG, { isFetching: false });
    }
  },
  checkout: async ({ commit }) => {
    commit(types.SET_BILLING_UI_FLAG, { isRedirecting: true });
    try {
      const { data } = await BillingAPI.checkout();
      if (data.url) {
        window.location.href = data.url;
      } else {
        commit(types.SET_BILLING_UI_FLAG, { isRedirecting: false });
        throwErrorMessage(new Error('missing redirect url'));
      }
    } catch (error) {
      commit(types.SET_BILLING_UI_FLAG, { isRedirecting: false });
      throwErrorMessage(error);
    }
  },
  portal: async ({ commit }) => {
    commit(types.SET_BILLING_UI_FLAG, { isRedirecting: true });
    try {
      const { data } = await BillingAPI.portal();
      if (data.url) {
        window.location.href = data.url;
      } else {
        commit(types.SET_BILLING_UI_FLAG, { isRedirecting: false });
        throwErrorMessage(new Error('missing redirect url'));
      }
    } catch (error) {
      commit(types.SET_BILLING_UI_FLAG, { isRedirecting: false });
      throwErrorMessage(error);
    }
  },
};

export const mutations = {
  [types.SET_BILLING_SUBSCRIPTION]($state, data) {
    $state.record = data;
  },
  [types.SET_BILLING_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
